module.exports = __webpack_public_path__ + "media/images/official/person01-30ca5169db7b9eefaeaa5cdab30ef4b3.svg";